import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Elements, StripeProvider } from 'react-stripe-elements';
import styled from 'styled-components';

import SmallSpinner from 'app/components/spinner';
import form from 'modules/ticketPublicPage/stores/tickets/form';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import facility from 'app/facility';
import { getLocale } from 'common/utils';

import config from '../../config';

import PaymentOptions from '../common/_paymentOptions';
import { TicketInlineAlerts } from '../common/_inlineAlert';

import { Container, WarningNote, BuyForm } from './styles/_details';
import DetailsContainer from './DetailsContainer';
import ActionButtons from './common/ActionButtons';

const {
  settings: { stripePublishKey },
} = facility;

const SmallSpinnerWrapper = styled.div`
  width: 200px;
`;

@observer
class Payment extends Component {
  render() {
    const { price } = view.activeObject;
    const isFree = !Number(price);
    const {
      formValues,
      errors,
      onBackToDetails,
      onNextBtnClick,
      serverError,
      payPalPaymentReady,
    } = form;

    const specificErrors = new Set(
      ['token', 'name', 'surname', 'email']
        .filter((field) => !!errors.get(field))
        .map((field) => errors.get(field))
    );

    if (payPalPaymentReady) {
      return (
        <BuyForm
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SmallSpinnerWrapper>
            <SmallSpinner />
          </SmallSpinnerWrapper>
          {i18n.gettext('We are processing your request...')}
        </BuyForm>
      );
    } else {
      return (
        <BuyForm>
          <Container>
            <DetailsContainer />
            <div>
              <div style={{ marginTop: '1.4rem' }}>
                {!isFree &&
                  (stripePublishKey ? (
                    <StripeProvider apiKey={stripePublishKey}>
                      <Elements locale={getLocale(config.language_code)}>
                        <PaymentOptions
                          form={form}
                          price={price * formValues.get('num')}
                        />
                      </Elements>
                    </StripeProvider>
                  ) : (
                    <PaymentOptions
                      form={form}
                      price={price * formValues.get('num')}
                    />
                  ))}
              </div>
              <WarningNote>
                <TicketInlineAlerts errors={[...specificErrors, serverError]} />
              </WarningNote>
            </div>
          </Container>
          <ActionButtons />
        </BuyForm>
      );
    }
  }
}

export default Payment;
